module.exports = __webpack_public_path__ + "img/bg-img-3-dark.5073f8da.png";